import { get } from 'lodash';

const submitBookingRequestForm = (_, dispatch, props) => {
  const {
    sendRequest,
    updateProgress,
    totalSteps,
    flowStep,
    booking
  } = props;
  const bookingError = 400 === get(booking, 'booking.error.statusCode');

  if (flowStep === totalSteps) {
    return sendRequest();
  }

  if (bookingError) {
    return;
  }

  dispatch(updateProgress(flowStep + 1));
};

export default submitBookingRequestForm;
